import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import reportWebVitals from "@/reportWebVitals";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "@/authentication/authConfig";

const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL before rendering the app
msalInstance.initialize().then(() => {
  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement
  );
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
});

// Export the instance for use in other parts of the app
export { msalInstance };
